import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) => ({
  root: {},
  inputWrapper: {
    '&>': {
      flip: false,
    },
    '& > input': {
      padding: theme.spacing(1, 0),
    },
    '[lang=ar] &': {
      '& input': {
        paddingRight: theme.spacing(0.75),
      },
    },
  },
  flag: {
    marginRight: theme.spacing(1),
    '[lang=ar] &': {
      marginRight: theme.spacing(-1),
      marginLeft: theme.spacing(1),
    },
  },
  mobilePrefix: {
    fontWeight: '500',
  },
}))
